import pie from "pistacja/plugin";
import Popover from "popover";
import CopyText from "copy-text";
import countdown from "countdown";
import TabsManager from "tabs-manager";
import PaginationSync from "pagination-sync";

pie.plugin(function Preparation({ device }) {
  // Handle Tabs.
  const tabs = TabsManager();

  // Handle Popovers.
  Popover();

  // Sync pagination w/ dynamic URL params.
  PaginationSync(["tab"]);

  // Select active tabs if user go from mobile to desktop.
  device({
    onDesktop() {
      tabs.initialize();
    },

    onMobile() {
      tabs.initialize();
    },
  });

  // Handle [data-copy] buttons.
  CopyText();

  const timer = document.getElementById("countdown-timer");
  timer &&
    countdown(timer.dataset.time, (time) => {
      timer.innerHTML = time.toString();
    });
});
